export default __webpack_public_path__ + "static/media/Archivo-Regular.b26f66ed.svg";